import { render, staticRenderFns } from "./adminOwnerDetail.vue?vue&type=template&id=526b5ffd&scoped=true"
import script from "./adminOwnerDetail.vue?vue&type=script&lang=js"
export * from "./adminOwnerDetail.vue?vue&type=script&lang=js"
import style0 from "./adminOwnerDetail.vue?vue&type=style&index=0&id=526b5ffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b5ffd",
  null
  
)

export default component.exports